import React from 'react';
import {connect} from 'react-redux';
import CKEditor from "react-ckeditor-component";
import ArrowButton from '../../button-arrow'
import {saveTextContent} from '../../../../actions/content'
import { getEnvironmentVariable } from '../../../../actions/environment-variable';
import './styles.css'

class InlineCKEditor extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      content:    '',
      identifier: ''
    }
  }

  updateContent = (newContent) => {
    this.setState({
      content: newContent
    });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.identifier && nextProps.contents) {
      this.setState({
        identifier: nextProps.identifier,
        content: this.state.content || nextProps.contents.body || ''
      });
    }
  }

  componentWillMount() {
    this.setState({
      identifier: this.props.identifier,
      content: this.props.contents ? this.props.contents.body : ''
    });

    if (this.props.licenseKey.length === 0) {
      this.props.dispatch(getEnvironmentVariable('REACT_APP_CKEDITOR_LICENSE_KEY'));
    }
  }

  onSaveContent = () => {
    this.props.dispatch(saveTextContent(this.state.identifier, this.state.content))
        .then(() => {
          if (typeof this.props.onContentSaved === 'function') {
            this.props.onContentSaved();
          }
        });
  };

  render() {
    const {content} = this.state;
    let $content = null;

    if (content) {
      $content = (
        <div dangerouslySetInnerHTML={{__html: content}}/>
      );
    } else {
      $content = '';
    }

    if (this.props.editContent && this.props.licenseKey.length === 0) {
      return (
        <div>Loading editor...</div>
      );
    }


    return (
      <div className="inline-editor">
        {this.props.editContent &&
        <div>
          <CKEditor content={content}
                    activeClass={this.props.activeClass}
                    scriptUrl="/api/ckeditor/ckeditor.js"
                    config={{
                      toolbar:
                        [
                          { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'MediaEmbed', 'PasteFromWord', '-', 'Undo', 'Redo'] },
                          { name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll'] },
                          { name: 'tools', items: ['Maximize', '-', 'About'] },
                          { name: 'document', items: ['Source'] },
                          '/',
                          { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv',
                            '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']
                          },
                          { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
                          { name: 'insert', items: ['base64image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'Iframe'] },
                          '/',
                          { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
                          { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                          { name: 'colors', items: ['TextColor', 'BGColor'] },
                        ],
                      extraPlugins: 'mediaembed,find,selectall,div,justify,smiley,specialchar,iframe,font,colorbutton,base64image',
                      extraAllowedContent: 'iframe[fullscreen,allowfullscreen]',
                      removedButtons: '',
                      licenseKey: this.props.licenseKey,
                      ...this.props.config
                    }}
                    events={{
                      change: (event) => this.updateContent(event.editor.getData())
                    }}/>
          <div className="mg-top-40">
          <ArrowButton arrow={false}
                       submit={false}
                       onClick={this.onSaveContent}>Save</ArrowButton>
          </div>
        </div>
        }
        {!this.props.editContent && $content}
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    editContent: state.viewConfig.editContent,
    licenseKey: state.environmentVariable.environmentVariableValue,
  };
};

export default connect(mapStateToProps)(InlineCKEditor);



// WEBPACK FOOTER //
// ./src/components/common/editor/inline-editor/index.jsx